module.exports = __webpack_public_path__ + "media/images/shop-dashboard-manager-icon-e8380fa07146954b507d0f77e5add8ad.png";